const roles = ["Administrator", "CoWorker", "Consultant","AuthorizedUser", "NewComer"];
export { roles };